module.exports = "/images/Collaborate with Co-Worker.png";